import { Controller } from '@hotwired/stimulus'
import { enter, leave } from 'el-transition'

export default class extends Controller {
  static targets = [
    'accountInputs',
    'credentialInputs',
    'dependentLabel',
    'serverInputs',
  ]

  static values = {
    accountPartners: Array,
    credentialPartners: Array,
    selected: String,
    serverPartners: Array,
  }

  handleSelectedChange(event) {
    this.selectedValue = event.target.value
  }

  selectedValueChanged() {
    const camelCaseSelected = this.
      selectedValue.
      replace(/_([a-z])/g, (g) => g[1].toUpperCase())

    const selectedKey = `${camelCaseSelected}Label`

    this.dependentLabelTargets.forEach((label) => {
      if (label.dataset[selectedKey]) {
        label.innerHTML = label.dataset[selectedKey]
      } else {
        label.innerHTML = label.dataset.defaultLabel
      }
    })

    if (this.accountPartnersValue.includes(this.selectedValue)) {
      enter(this.accountInputsTarget)
    } else {
      leave(this.accountInputsTarget)
    }

    if (this.credentialPartnersValue.includes(this.selectedValue)) {
      enter(this.credentialInputsTarget)
    } else {
      leave(this.credentialInputsTarget)
    }

    if (this.serverPartnersValue.includes(this.selectedValue)) {
      enter(this.serverInputsTarget)
    } else {
      leave(this.serverInputsTarget)
    }
  }
}
